import { InstagramCreator } from '@frontend/gql/social/graphql';

export interface CreatorAvatarHeaderComponentProps {
  profilePictureUrl?: string | null;
  username: string;
  isVerified: boolean;
  isLoading: boolean;
  clickedCreators: InstagramCreator[];
  originalCreator: Pick<InstagramCreator, 'username'> | null;
  onReturnToOriginalCreator: () => void;
}

export const useCreatorAvatarHeaderProps = (
  creator: InstagramCreator | null,
  isLoading: boolean,
  clickedCreators: InstagramCreator[],
  originalCreator: Pick<InstagramCreator, 'username'> | null,
  onReturnToOriginalCreator: () => void
): CreatorAvatarHeaderComponentProps => {
  return {
    profilePictureUrl: creator?.profilePictureUrl,
    username: creator?.username ?? '',
    isVerified: creator?.isVerified ?? false,
    isLoading,
    clickedCreators,
    originalCreator,
    onReturnToOriginalCreator,
  };
};
